import {forwardRef} from 'react';
import classNames from 'classnames';
import {ThemeVariables} from '@/style/Theme';
import {Button as LuffyButton, ButtonProps as LuffyButtonProps} from '@baidu/luffy-comp-button';
import styles from './index.module.scss';


export enum ButtonType {
    Normal = 'normal',
    Important = 'important',
    Plain = 'plain',
    Intensive = 'intensive',
    WithArrow = 'withArrow',
}

export enum ButtonShape {
    Normal = 'normal',
    Capsule = 'capsule',
    Circle = 'circle',
}

export enum ButtonColor {
    Normal = 'normal',
    Error = 'error',
    Success = 'success',
    Primary = 'primary',
    Secondary = 'secondary',
}

export enum ButtonSize {
    XS = 'xs',
    SM = 'sm',
    MD = 'md',
    LG = 'lg',
}

type SuperButtonType = LuffyButtonProps['type'] | ButtonType.WithArrow;

interface ButtonProps extends Omit<LuffyButtonProps, 'type'> {
    border?: boolean;
    type?: SuperButtonType;
    noMinWidth?: boolean;
}

const Button = forwardRef<LuffyButton, ButtonProps>((props: ButtonProps, ref) => {
    const {type} = props;
    const {children, border = false, className, ...buttonProps} = props;
    const isArrowType = type === ButtonType.WithArrow;

    const buttonClass = classNames(
        isArrowType ? styles.link : '',
        buttonProps?.noMinWidth && styles.root,
        border && styles.border,
        border && type === ButtonType.Plain && styles.borderPadding,
        className
    );
    const luffyBtnType = isArrowType ? ButtonType.Plain : type;

    delete buttonProps.noMinWidth;
    return (
        <LuffyButton className={buttonClass} {...buttonProps} type={luffyBtnType as LuffyButtonProps['type']} ref={ref}>
            {children}
            {
                isArrowType &&
                <div className={
                    classNames(
                        styles.arrow,
                        styles[`arrow${buttonProps?.color || ButtonColor.Normal}`]
                    )}
                >
                </div>
            }
        </LuffyButton>
    );
});

export default Button;
